// @flow

/**
 * Ensures that user has either signed up via Drip or has
 * clicked the "nah, just show me the calculator" link.
 */

import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import type { ComponentType } from 'react';

function hasBypassedSignUp(bypassName: string = 'bypass', manualBypass: boolean = false): boolean {
  // console.log('hasBypassedSignUp', bypassName, manualBypass);

  if (!window.Modernizr.localstorage) {
    // console.log('No localStorage');
    return manualBypass;
  }

  const bypassState = localStorage.getItem(bypassName) ? true : false;
  // console.log('bypassState', bypassState);

  return bypassState;
}

type Props = {
  component: ComponentType<any>,
  bypassName?: string,
  location?: { [string]: any },
  resourceName?: string
}

const PrivateRoute = ({ component, ...rest }: Props) => {
  const Component = component; // can't destructure with flow-type

  let manualBypass: boolean = false;
  if (rest.location != null && rest.location.state != null) {
    manualBypass = rest.location.state.bypass ? true : false;
  }
  const hasBypassed = hasBypassedSignUp(rest.bypassName, manualBypass);
  // console.log('manualBypass', manualBypass);
  // console.log('hasBypassed', hasBypassed);

  return (
    <Route
      {...rest}
      render={props =>
        hasBypassed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/sign-up',
              state: {
                bypassName: rest.bypassName,
                referrer: props.location,
                resourceName: rest.resourceName
              }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js